var _rect, _rect2, _path, _circle, _rect3, _rect4, _path2, _ellipse, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArmsWorking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 36,
    viewBox: "0 0 64 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28.5752,
    width: 5,
    height: 2,
    rx: 1,
    transform: "rotate(-31.0052 44 28.5752)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 3,
    width: 6,
    height: 20,
    rx: 3,
    transform: "rotate(-30 48 3)",
    fill: "#6D6D6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4403 28.3453C48.7656 28.9309 47.753 28.8951 47.1214 28.2634C46.4897 27.6318 46.4539 26.6192 47.0395 25.9445L57.1758 14.2657C58.2386 13.0411 60.1169 12.9748 61.2635 14.1213C62.41 15.2679 62.3437 17.1462 61.1191 18.209L49.4403 28.3453Z",
    fill: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.0942,
    cy: 16.5322,
    r: 1.5,
    fill: "#6D6D6D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.92728,
    height: 1.98954,
    rx: 0.994771,
    transform: "matrix(-0.852505 -0.522719 -0.507544 0.861626 19 28.5752)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.91089,
    height: 19.9015,
    rx: 2.95545,
    transform: "matrix(-0.86163 -0.507537 -0.4925 0.870312 15.0794 3)",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6677 28.3453C14.329 28.9309 15.3215 28.8951 15.9406 28.2634C16.5597 27.6318 16.5948 26.6192 16.0209 25.9445L6.08579 14.2657C5.04406 13.0411 3.203 12.9748 2.0792 14.1213C0.955408 15.2679 1.02042 17.1462 2.22068 18.209L13.6677 28.3453Z",
    fill: "#303030"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.47022,
    ry: 1.5,
    transform: "matrix(-1 0 0 1 4.20537 16.5322)",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8878 30.1816L44.778 30.7359L45.1706 31.9125C45.2233 32.0719 45.0721 32.223 44.9139 32.1691L43.7373 31.7766L43.1818 32.8875C43.1068 33.0375 42.8935 33.0375 42.8185 32.8875L42.2642 31.7777L41.0864 32.1703C40.927 32.223 40.7758 32.0719 40.8297 31.9137L41.2223 30.7371L40.1125 30.1816C39.9625 30.1066 39.9625 29.8934 40.1125 29.8184L41.2223 29.2641L40.8297 28.0863C40.777 27.927 40.9282 27.7758 41.0864 27.8297L42.263 28.2223L42.8173 27.1125C42.8923 26.9625 43.1056 26.9625 43.1806 27.1125L43.7349 28.2223L44.9116 27.8297C45.0709 27.777 45.2221 27.9281 45.1682 28.0863L44.7756 29.2629L45.8854 29.8172C46.0378 29.8934 46.0378 30.1066 45.8878 30.1816Z",
    fill: "#FFC82C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6591 32.2442L23.6637 32.7857L23.9191 34.8371C23.9529 35.1148 23.6563 35.3122 23.4155 35.1722L21.6217 34.1445L20.3494 35.7775C20.1776 35.998 19.829 35.928 19.7557 35.6582L19.2142 33.6629L17.1608 33.9178C16.883 33.9517 16.6856 33.655 16.8256 33.4142L17.8533 31.6206L16.2222 30.3486C16.0017 30.1769 16.0717 29.8283 16.3414 29.755L18.3368 29.2136L18.0818 27.1602C18.048 26.8825 18.3446 26.6851 18.5854 26.8251L20.3792 27.8528L21.6493 26.2213C21.821 26.0009 22.1696 26.0709 22.2429 26.3406L22.7844 28.3359L24.8359 28.0806C25.1137 28.0468 25.3111 28.3434 25.1711 28.5842L24.1434 30.3779L25.7749 31.6479C25.9989 31.8224 25.9289 32.1709 25.6591 32.2442Z",
    fill: "#FFC82C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmsWorking);
export default __webpack_public_path__ + "static/media/arms-working.a88f0b6237dd26248973668f1a562cb8.svg";
export { ForwardRef as ReactComponent };